import { render, staticRenderFns } from "./DialogSort.vue?vue&type=template&id=67602fd9&scoped=true"
import script from "./DialogSort.vue?vue&type=script&lang=js"
export * from "./DialogSort.vue?vue&type=script&lang=js"
import style0 from "./DialogSort.vue?vue&type=style&index=0&id=67602fd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67602fd9",
  null
  
)

export default component.exports